export const apiCreateDeposite = "/1.0/wsm/wallet/create/deposit"
export const apiCreateWithdrawal = "/1.0/wsm/wallet/create/withdrawal"
export const apiListTransaction = "/1.0/wsm/wallet/list"
export const apiDetailTransaction = (id) => `/1.0/wsm/wallet/${id}/detail`
export const apiBrowseTransaction = (id) => `/1.0/wsm/wallet/${id}/browse`
export const apiRefuseTransaction = (id) => `/1.0/wsm/wallet/${id}/refuse`

export const apiListTransactionLeader = "/1.0/wsm/leader/wallet/list"
export const apiCreateDepositeLeader = "/1.0/wsm/leader/wallet/create/deposit"
export const apiDetailTransactionLeader = (id) => `/1.0/wsm/leader/wallet/${id}/detail`
export const apiListTransactionStaff = "/1.0/wsm/staff/wallet/list"
export const apiGetBankAccInfo = `/1.0/wsm/staff/wallet/infor`
export const apiCreateDepositeStaff = `/1.0/wsm/staff/wallet/create/deposit`
export const apiCreateWithdrawalStaff = `/1.0/wsm/staff/wallet/create/withdraw`
export const apiUpdateBankInfo = `/1.0/wsm/staff/wallet/update`

export const apiBankingQr = `/1.0/wsm/bank/createQr`

